import {
  RetryOptions,
  RetryScope,
  configureRetry,
} from 'src/shared/helpers/retry';

const networkErrorTest = /\/network-request-failed$/;

export type FirebaseError = Error & { code?: string };
export const isNetworkError = (
  error: FirebaseError | unknown,
): error is FirebaseError => {
  if (!error) return false;

  return networkErrorTest.test((error as FirebaseError).code ?? '');
};

export const defaultRetryTest = (_: RetryScope, result: unknown) => {
  let retry = false;
  let message = '';
  if (isNetworkError(result)) {
    retry = true;
    message = result.message;
  }
  return {
    retry,
    message,
  };
};

export const configureFirebaseRetry = (options?: RetryOptions) => {
  const retryOptions = options ?? {};
  const retryTest = retryOptions.retryTest ?? defaultRetryTest;
  const { withRetry } = configureRetry({ ...retryOptions, retryTest });

  return withRetry;
};
